<template>
  <g>
    <path
      d="M18.3471 21H5.65187C5.19196 21 4.81883 20.6647 4.78412 20.2395L4.50644 16.3799C4.40231 14.9571 5.57377 13.3216 7.0663 12.8065C10.2509 11.7271 13.7567 11.7353 16.9326 12.8065C18.4338 13.3298 19.6053 14.9652 19.4925 16.3881L19.2148 20.2477C19.1801 20.6647 18.807 21 18.3471 21ZM6.45888 19.3646H17.5314L17.757 16.2654C17.8004 15.6276 17.1843 14.63 16.3339 14.3356C13.5571 13.3952 10.4505 13.3952 7.65637 14.3356C6.81466 14.63 6.18988 15.6358 6.23326 16.2736L6.45888 19.3646Z"
      :fill="iconColor"
    />
    <path
      d="M12 11C9.51562 11 7.5 8.9842 7.5 6.5C7.5 4.0158 9.51562 2 12 2C14.4844 2 16.5 4.0158 16.5 6.5C16.4906 8.9842 14.475 11 12 11ZM12 3.67286C10.5562 3.67286 9.375 4.94424 9.375 6.5C9.375 8.05576 10.5562 9.32714 12 9.32714C13.4437 9.32714 14.625 8.05576 14.625 6.5C14.6156 4.94424 13.4437 3.67286 12 3.67286Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#616161"
    }
  }
};
</script>
